export class CacheBusterUtils {
	/**
	 * Appends a cache-busting query parameter to a URL using Unix timestamp
	 * @param url The URL to add cache buster to
	 * @param seed
	 * @param paramName The query parameter name (default: 'cb')
	 * @returns URL with cache buster appended
	 */
	static appendCacheBusterToUrl(url: string | undefined, seed?: number, paramName: string = 'cb'): string | undefined {
		if (!url) {
			return url;
		}

		// Don't add cache buster to data URLs or URLs that already have the parameter
		if (url.startsWith('data:') || url.includes(`${paramName}=`)) {
			return url;
		}

		// If no seed was provided, generate our own using the current timestamp
		if (seed === undefined || seed === null) {
			seed = Date.now();
		}
		const separator = url.includes('?') ? '&' : '?';
		return `${url}${separator}${paramName}=${seed}`;
	}

	/**
	 * Adds cache buster to an asset object's assetPath property
	 * @param asset Asset object with assetPath
	 * @returns Asset with cache-busted assetPath
	 */
	static addCacheBusterToAsset<T extends { assetPath?: string }>(asset: T): T {
		if (!asset || !asset.assetPath) {
			return asset;
		}

		return {
			...asset,
			assetPath: CacheBusterUtils.appendCacheBusterToUrl(asset.assetPath)
		};
	}
}
